export default "__VITE_ASSET__CeANORn4__"